
const serviceNameMapping = {
  hap_dms_server: 'DMS App Server',
  hap_cloud_code: 'Cloud Code',
  hap_notification_manager: 'Notification Manager',
  hap_auth_manager: 'Auth Manager',
  hap_identity_manager: 'Identity Manager',
  hap_iportal: 'iPortal',
  hap_document_store: 'Document Store',
  hap_least_load: 'Load Balancer',
  hap_iristest_as: 'ITAS',
  hap_tnps: 'TNPS Server',
  hap_xfinityvoice_as: 'XVAS Server',
  hap_dms_portal: 'DMS Portal',
  hap_event_manager: 'Event Manager',
};

const convertDisplayName = data => serviceNameMapping[data];

export default convertDisplayName;
